export enum UploadHubRoleEnum {
  EMPTY,
  ADMIN,
  PROPERTY_MANAGER,
  FINANCIAL_MANAGER,
}
